import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import { connect } from 'react-redux';

const AppLoader = props => {
  const { appStatus } = props;
  const loading = appStatus === "loading";

  return (
    loading ?
      <View style={styles.modalBackground}>
        <View style={styles.activityIndicatorWrapper}>
          <ActivityIndicator
            animating={loading} size="large" />
        </View>
      </View> : null
  );
};

function mapStateToProps(state) {
  return {
    appStatus: state.appStatus
  };
}

AppLoader.propTypes = {
  appStatus: PropTypes.string
};

export default connect(mapStateToProps)(AppLoader);

const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    alignItems: 'center',
    position: 'absolute',
    zIndex: 900,
    height: '100%',
    width: '100%',
    justifyContent: 'space-around',
    backgroundColor: '#00000040'
  },
  activityIndicatorWrapper: {
    backgroundColor: '#FFFFFF',
    height: 80,
    width: 80,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around'
  }
});
